module.exports = __webpack_public_path__ + "static/media/2.a97fb62f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/2.png
// module id = 1393
// module chunks = 0